import loaded from '@/scripts/utils/loaded.js';

loaded(() => {
    document.querySelectorAll('#press-container .item').forEach((el, index) => {
        setTimeout(function () {
            el.classList.add('slide-in');
        }, 200 * index);
    });

    // Was a setInterval that re-added the class every 100ms forever; adding it once is equivalent.
    setTimeout(function () {
        document.getElementById('press__hero')?.classList.add('fade-in')
    }, 100);
});
